import React, { useState, useEffect, useMemo } from "react";
import UserHeader from "../Header/UserHeader/UserHeader";
import { authData } from "../../redux/auth/authSlice";
import { FaBars } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  Paper,
  Typography,
  Skeleton,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import swal from "sweetalert";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { ReactComponent as Close } from "../../assets/svg/close_black_24dp.svg";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperSectionMainStyle: {
    width: "40rem",
    backgroundColor: "#d5e3ef",
    padding: "1.5rem",
    boxShadow: "0 0 1px #0000002e",
    "@media (max-width: 520px)": { width: "100%" },
  },
  paperSectionStyle: {
    boxShadow: "0 0 8px #0000002e",
    marginTop: "1.5rem",
    padding: "1.5rem",
  },
}));

const Iamarks = ({ handleToggleSidebar }) => {
  const classes = useStyles();
  const userDetails = useSelector(authData);

  const [selectedPgm, setSelectedPgm] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState("");
  const [coursesThisSemester, setCoursesThisSemester] = useState([]);
  const [iaMarksData, setIaMarksData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Modal + concern states
  const [open, setOpen] = useState(false);
  const [currentTopic, setCurrentTopic] = useState(null);
  const [reason, setReason] = useState("");
  const [reasonErr, setReasonErr] = useState("");

  const programlist = userDetails.data?.bpdata || [];

  const tdStyle1 = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "14px",
  };

  const thStyle = {
    backgroundColor: "var(--sub-heading-color)",
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "16px",
    color: "#ddd",
  };

  const thStyle1 = {
    backgroundColor: "var(--sub-heading-color)",
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "16px",
    color: "#ddd",
  };

  const tdStyle = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "1.4rem",
    cursor: "pointer",
    fontWeight: "500",
    color: "var(--sub-heading-color)",
    // or "500", "normal", etc.
  };


  const pgmIaMarks = useMemo(() => {
    if (!selectedPgm?.ptitle) return 25;
    const title = selectedPgm.ptitle.toLowerCase();
    if (title.includes("b.sc") || title.includes("bsc")) return 30;
    if (title.includes("diploma")) return 50;
    return 25;
  }, [selectedPgm]);

  // Auto-select first program if list exists and nothing selected
  useEffect(() => {
    if (programlist.length > 0 && !selectedPgm) {
      setSelectedPgm(programlist[0]);
    }
  }, [programlist]);

  // When program changes → reset semester + fetch courses
  useEffect(() => {
    if (!selectedPgm) {
      setSelectedSemester("");
      setCoursesThisSemester([]);
      setIaMarksData([]);
      return;
    }

    // Reset dependent states
    setSelectedSemester("");
    setIaMarksData([]);
    setCoursesThisSemester([]);

    getCourseDetailsForUser(selectedPgm);
  }, [selectedPgm]);

  // When semester or courses change → fetch IA marks for visible courses
  useEffect(() => {
    if (!selectedPgm || !selectedSemester || coursesThisSemester.length === 0) {
      setIaMarksData([]);
      return;
    }

    const filteredCourses = coursesThisSemester.filter(
      (course) => String(course.semester) === String(selectedSemester)
    );

    const topicIds = filteredCourses
      .map((course) => course.bcid)
      .filter(Boolean);

    if (topicIds.length > 0) {
      getIaMarks(topicIds);
    } else {
      setIaMarksData([]);
    }
  }, [selectedSemester, coursesThisSemester, selectedPgm]);

  
  const getCourseDetailsForUser = async (program) => {
    if (!program?.bpid || !program?.pid) return;

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: program.bpid,
        pid: program.pid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_COURSE_DETAILS_FOR_USER,
        bodyParam
      );

      let allCourses = response.pcurriculum || [];

      const userCourses = userDetails.curprg?.scourses || [];

      // Enrich + normalize course data
      allCourses = allCourses.map((course) => {
        const match = userCourses.find((uc) => uc.bcid === course.btid);
        return {
          ...course,
          bcid: course.btid,
          per: match ? match.per : 0,
          semester: course.semester ?? 1,
          vcourse: course.telective && !match ? true : undefined,
        };
      });

      // Exclude deselected elective courses
      allCourses = allCourses.filter((course) => {
        return !userCourses.some(
          (uc) =>
            uc.selected === false &&
            uc.bcid === course.btid &&
            course.telective
        );
      });

      // Remove virtual courses
      allCourses = allCourses.filter((course) => !course.vcourse);

      setCoursesThisSemester(allCourses);
    } catch (err) {
      console.error("Error fetching course details:", err);
      setCoursesThisSemester([]);
    }
  };


  const getIaMarks = async (topicIds) => {
    if (!topicIds?.length || !selectedPgm?.bpid) return;

    setLoading(true);

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: selectedPgm.bpid,
        topicids: topicIds,
        eid: userDetails.eid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getIaMarks",
        bodyParam
      );
      setIaMarksData(Array.isArray(response) ? response : [response]);
    } catch (err) {
      console.error("Error fetching IA marks:", err);
      setIaMarksData([]);
      swal("Error", "Failed to load IA marks. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };


  const handleRaiseConcern = async (topicKey, concernRaised, topicName) => {
    if (concernRaised === "true" && !reason.trim()) {
      setReasonErr("Please enter the reason for concern");
      return;
    }

    setOpen(false);

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: selectedPgm.bpid,
        topicids: [topicKey],
        eid: userDetails.eid,
        concernRaised,
        topicName,
        email: userDetails?.email,
        name: userDetails?.name,
        reason: concernRaised === "true" ? reason : "",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setLoading(true);
    try {
      const res = await API.post(
        config.aws_cloud_logic_custom_name,
        "/UpdateIaConcern",
        bodyParam
      );

      if (res.statusCode === 200) {
        swal("Success", "Concern updated successfully", "success");
        // Refresh IA marks
        const topicIds = coursesThisSemester
          .filter((c) => String(c.semester) === String(selectedSemester))
          .map((c) => c.bcid)
          .filter(Boolean);
        if (topicIds.length > 0) await getIaMarks(topicIds);
      } else {
        throw new Error("API returned non-200 status");
      }
    } catch (err) {
      console.error(err);
      swal("Error", "Failed to update concern", "error");
    } finally {
      setLoading(false);
      setReason("");
      setReasonErr("");
    }
  };

  const handleConfirmNoConcern = (topicKey, topicName) => {
    swal({
      title: "Are you sure?",
      text: "No Concern?",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: false,
    }).then((willConfirm) => {
      if (willConfirm) {
        handleRaiseConcern(topicKey, "false", topicName);
      }
    });
  };

  const handleOpenModal = (topic) => {
    setCurrentTopic({
      topicKey: topic.topicKey || Object.keys(iaMarksData[0]?.topics || {}).find(k => iaMarksData[0]?.topics[k] === topic),
      topicName: topic.topicName,
    });
    setReason("");
    setReasonErr("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentTopic(null);
    setReason("");
    setReasonErr("");
  };

  
  return (
    <main style={{ padding: "1.5rem" }}>
      <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
        <FaBars />
      </div>
      <UserHeader />

      
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "2rem",
              width: "90%",
              maxWidth: "600px",
              outline: "none",
            }}
          >
            <div style={{ textAlign: "right", marginBottom: "1rem" }}>
              <Close
                onClick={handleClose}
                style={{ cursor: "pointer", width: "28px" }}
              />
            </div>

            <div style={{ display: "grid", gap: "1.2rem", gridTemplateColumns: "1fr 2fr" }}>
              <div style={{ fontWeight: "bold" ,  fontSize: "14px",}}>Course Name</div>
              <div style={{ fontWeight: "bold" ,  fontSize: "14px",}}>{currentTopic?.topicName || "—"}</div>

              <div style={{ fontWeight: "bold",  fontSize: "14px", }}>
                Reason for concern <span style={{ color: "red" }}>*</span>
              </div>
              <textarea
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  setReasonErr("");
                }}
                style={{
                  height: "100px",
                  padding: "12px",
                 
                  border: "1px solid #01498e",
                  borderRadius: "6px",
                  resize: "vertical",
                   fontSize: "14px",
                }}
                placeholder="Enter your concern here..."
              />
            </div>

            {reasonErr && (
              <p style={{ color: "red", textAlign: "center", marginTop: "1rem" }}>
                {reasonErr}
              </p>
            )}

            <div style={{ display: "flex",
                    gap: "50px",
                    justifyContent: "center",
                    paddingTop: "2rem", }}>
              <button
                onClick={() =>
                  handleRaiseConcern(
                    currentTopic?.topicKey,
                    "true",
                    currentTopic?.topicName
                  )
                }
                style={{
                 fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "var(--sub-heading-color)",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                }}
              >
                Yes
              </button>
              <button
                onClick={handleClose}
                style={{
                  fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "white",
                      color: "var(--sub-heading-color)",
                      border: "0.5px solid var(--sub-heading-color)",
                      borderRadius: "4px",
                }}
              >
                NO
              </button>
            </div>
          </div>
        </Fade>
      </Modal>

      <h2 style={{ fontSize: "2rem", fontWeight: 700, margin: "1.5rem 0 2rem" }}>
        IA Marks
      </h2>

     
      <Paper className={classes.paperSectionMainStyle}>
        <h4 style={{ margin: 0, marginBottom: "0.8rem" }}>Program</h4>
        <select
          value={selectedPgm ? JSON.stringify(selectedPgm) : ""}
          onChange={(e) => {
            const val = e.target.value;
            if (!val) return;
            try {
              const pgm = JSON.parse(val);
              setSelectedPgm(pgm);
            } catch {}
          }}
          style={{
            width: "100%",
            height: "48px",
            fontSize: "1.4rem",
            padding: "0 1rem",
            border: "1px solid #01498e",
            borderRadius: "6px",
            background: "white",
          }}
        >
          <option value="">-- Select Program --</option>
          {programlist.map((pgm, idx) => (
            <option key={idx} value={JSON.stringify(pgm)}>
              {pgm.ptitle}
            </option>
          ))}
        </select>
      </Paper>

     
      {selectedPgm && (
        <Paper className={classes.paperSectionMainStyle} style={{ marginTop: "1.2rem" }}>
          <h4 style={{ margin: 0, marginBottom: "0.8rem" }}>Semester</h4>
          <select
            value={selectedSemester}
            onChange={(e) => setSelectedSemester(e.target.value)}
            style={{
              width: "100%",
              height: "48px",
              fontSize: "1.4rem",
              padding: "0 1rem",
              border: "1px solid #01498e",
              borderRadius: "6px",
              background: "white",
            }}
          >
            <option value="">-- Select Semester --</option>
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <option key={n} value={n}>
                Semester {n}
              </option>
            ))}
          </select>
        </Paper>
      )}

      
      {loading ? (
        <div style={{ marginTop: "2.5rem" }}>
          
          <Skeleton variant="rectangular" height={200} style={{ marginTop: "1rem" }} />
        </div>
      ) : selectedPgm && selectedSemester && iaMarksData.length > 0 ? (
        <Paper className={classes.paperSectionStyle}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "1.1rem",
            }}
          >
            <thead>
              <tr>
                <th style={thStyle1}>Course</th>
                <th style={thStyle1}>Marks Scored</th>
                <th style={thStyle}>Concern Status</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(iaMarksData[0]?.topics || {}).map(([key, topic]) => {
                if (!topic.showIaMarks) return null;

              

                return (
                  <tr key={key}>
                     <td style={tdStyle}>{topic.topicName}</td>
                      <td style={tdStyle}>
                        {topic.Iamarks} / {pgmIaMarks}
                      </td>
                    <td style={tdStyle1}>
                        {topic?.concernRaised ? (
                          <button
                            style={{
                              backgroundColor: "var(--sub-heading-color)",
                              width: "13rem",
                              height: "30px",
                              fontSize: "1.4rem",
                              border: "none",
                              color: "white",
                              borderRadius: "4px",
                              fontWeight: "500",
                            }}
                          >
                            {topic.concernRaised === "true"
                              ? "Concern Raised"
                              : topic.concernRaised === "Updated"
                                ? "Updated"
                                : "No Concern"}
                          </button>
                        ) : (
                          <div>
                            {topic.showConcernButton && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "1rem",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--sub-heading-color)",
                                      width: "13rem",
                                      height: "30px",
                                      fontSize: "1.4rem",
                                      border: "none",
                                      color: "white",
                                      borderRadius: "4px",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      setCurrentTopic(topic);
                                      setOpen(true);
                                    }}
                                  >
                                    Raise Concern
                                  </button>
                                  <button
                                     onClick={() => handleConfirmNoConcern(key, topic.topicName)}
                                    style={{
                                      backgroundColor:
                                        "var(--sub-heading-color)",
                                      width: "13rem",
                                      height: "30px",
                                      fontSize: "1.4rem",
                                      border: "none",
                                      color: "white",
                                      borderRadius: "4px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    No Concern
                                  </button>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "0.5rem",
                                    alignItems: "center",
                                    fontSize: "1.2rem",
                                    justifyContent: "center",
                                  }}
                                >
                                  <InfoOutlinedIcon
                                    style={{ width: "1.2rem" }}
                                  />
                                  <p>
                                    These options will be available only for 72
                                    hours from time of visibility
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Paper>
      ) : selectedPgm && selectedSemester ? (
        <Typography variant="h6" style={{ marginTop: "3rem", color: "#555" }}>
          No IA marks available for the selected program and semester.
        </Typography>
      ) : null}
    </main>
  );
};

export default Iamarks;